import List from "@mui/material/List";
import { MenuItem } from "src/framework/components/navigations";
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useEffect, useState } from "react";
import { LogoSolar } from "src/framework/components/commons";
import { NavLink } from "react-router-dom";
import { useObservable } from "src/framework/store/storeUtil";
import { useMediaQuery } from "@mui/material";
import theme from "src/theme/light";
import { mobileWidth } from "src/framework/layouts";
import { segmento$, tipoVenda$ } from "src/store/global.store";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { openMenu$ } from "src/framework/store/AppStore";
import { permissoes$ } from "src/framework/store/LoginStore";

const Menu = ({ classes, onClose, handleRedirectProjetos }: { classes: any, onClose: any, handleRedirectProjetos: any }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const menuWidth = isMobile ? mobileWidth : 288;

  const [menuActived, setMenuActived] = useState<number>(-1);
  const openMenu = useObservable(openMenu$);
  const segmento = useObservable(segmento$);
  const tipoVenda = useObservable(tipoVenda$);

  useEffect(() => {
    if (tipoVenda === 'avulso') {
      setMenuActived(3);
    } else {
      if (segmento === 'on') {
        setMenuActived(1);
      }
      if (segmento === 'off') {
        setMenuActived(2);
      }
    }
  }, [openMenu, segmento, tipoVenda]);

  return (
    <div className={classes.drawerContainer}>
      <div className={classes.menuBox}>
      <NavLink to={"/"}>
          <LogoSolar
            fillIntelbras={"#00B26B"}
            width={`200px`}
          />
        </NavLink>
      </div>
      <Scrollbars key={"scrollbar-menu"} style={{ width: menuWidth, height: "calc(100vh - 64px - 72px - 40.03px - 20px)" }}>
        <List>
          <MenuItem
            index={0}
            nested={false}
            menuItem={{
              text: "Plataforma Solar",
              icon: null,
              isSubItem: false,
              link: "",
            }}
            current={menuActived}
            key={`menu-menu-${0}`}
            setCurrent={handleRedirectProjetos}
          />

          {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_ONGRID, permissoes$.value) && (
            <MenuItem
              index={1}
              nested={false}
              menuItem={{
                text: "Loja On Grid",
                icon: null,
                isSubItem: false,
                link: "",
              }}
              current={menuActived}
              key={`menu-menu-${1}`}
              setCurrent={(value: number) => {
                setMenuActived(value);
                segmento$.next("on");
                tipoVenda$.next("gerador");
                onClose();
              }}
            />
          )}

          {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_OFFGRID, permissoes$.value) && (
            <MenuItem
              index={2}
              nested={false}
              menuItem={{
                text: "Loja Off Grid",
                icon: null,
                isSubItem: false,
                link: "",
              }}
              current={menuActived}
              key={`menu-menu-${2}`}
              setCurrent={(value: number) => {
                setMenuActived(value);
                segmento$.next("off");
                tipoVenda$.next("gerador");
                onClose();
              }}
            />
          )}

          {PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_AVULSO, permissoes$.value) && (
            <MenuItem
              index={3}
              nested={false}
              menuItem={{
                text: "Avulso",
                icon: null,
                isSubItem: false,
                link: "",
              }}
              current={menuActived}
              key={`menu-menu-${3}`}
              setCurrent={(value: number) => {
                setMenuActived(value);
                tipoVenda$.next("avulso");
                onClose();
              }}
            />
          )}
        </List>
      </Scrollbars>
    </div>
  );
};
export { Menu };
